var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 3.6H5.4V2.7H12.6V3.6H14.4V2.7H16.2V5.4H1.8V2.7H3.6V3.6ZM1.8 7.2V16.2H16.2V7.2H1.8ZM5.4 0.9H12.6V0H14.4V0.9H16.2C17.1941 0.9 18 1.70589 18 2.7V16.2C18 17.1941 17.1941 18 16.2 18H1.8C0.805888 18 0 17.1941 0 16.2V2.7C0 1.70589 0.805888 0.9 1.8 0.9H3.6V0H5.4V0.9Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7223376cad03c9a4d2c7e8b3ca1ef4d8.svg";
export { ForwardRef as ReactComponent };